import {createSelector} from '@reduxjs/toolkit';
import type {Store} from 'store';

const x = (store: Store) => store;

export const isSearch = createSelector(x, store => !!store.files.search);
export const getLayout = createSelector(x, store => store.files.layout);
export const getRoot = createSelector(x, store => store.files.root);
export const getSelection = createSelector(x, store => store.files.selection);
export const getPreview = createSelector(x, store => store.files.preview);
export const getPreviewProgress = createSelector(x, store => store.files.previewProgress);
export const getSearch = createSelector(x, store => store.files.search);
export const getFilter = createSelector(x, store => store.files.filter);
export const getDrag = createSelector(x, store => store.files.drag);
export const getPick = createSelector(x, store => store.files.pick);
export const getSort = createSelector(x, store => store.files.sort);
export const getQuery = createSelector(x, store => store.files.query);
export const getItems = createSelector(x, store => store.files.items);
export const getViews = createSelector(x, store => store.files.views);
export const getItem = (path: string) => createSelector(x, store => store.files.items[path]);
export const getView = (path: string) => createSelector(x, store => store.files.views[path]);
export const getParent = (path: string) => createSelector(x, store => {
  const item = path && store.files.items[path];
  const parentKey = item?.parentKey || 'myfiles';
  return parentKey;
});


export const hasPrivateItems = (ids: string[]) => createSelector(x, store => {
  for (let i = 0; i < ids.length; i++) {
    const item = store.files.items[ids[i]];
    if (item && (item.private || item.shareLinkEnabled === false)) {
      return true;
    }
  }
  return false;
});
